<template>
    <div @click.stop.prevent="handleClick">
        <div class="row">
            <div class="col-12 col-xs-12 col-sm-6">
                <h3 class="txt--xl">
                    {{title}}
                </h3>
                <p>{{description}}</p>
            </div>
            <div class="col-12 col-xs-12 col-sm-6">                
                <label class="calculator__label visually-hidden" :for="id">{{title}}</label>
                <InputTextElement :id="id" v-model="value" @input="typing()"/> 
            </div>
        </div> 
        <hr  class="mb-2 mb--2">
    </div>
</template>

<script>
import InputTextElement from '@/components/inputs/InputTextElement';
	export default {
		name: "InputText",
		components: {
			InputTextElement
		},
        props: {
			title: String,
			description: String,
			id: String,
			change: Function,
			errorCheck : Boolean
		},
		methods: {
								
			handleClick(e) {
				if (e.target.matches("a")) {
					let url = e.target.href;
					let target = e.target.target == "_blank" ? "_blank" : "_self";
					let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
					var isnativeapp = document.getElementById("isnativeapp");
					if (isnativeapp === undefined || isnativeapp === null) 
					{
						window.open(url,target);  
					}
					else{
						if(target == "_blank") {
							let data = {title:'',nodeid: dataId, href:url, target: target};
							window.Native('dataCallback', data);
						} 
					}	
				}
			},
			
			typing() {				
                this.$emit("inputPress");
			},            
			initialState() {                 
				return {
					value: null
				}
			},			
			reset() {
				Object.assign(this.$data, this.initialState());
			},

		}, 
        data() {            
			return this.initialState();
        }
	};
</script>